import ColorPicker from "@stimulus-components/color-picker"
import Pickr from "@simonwep/pickr"

export default class extends ColorPicker {
  connect() {
    // Override connect to include i18n options
    this.picker = Pickr.create({
      el: this.buttonTarget,
      theme: this.themeValue,
      position: "bottom-start",
      comparison: true,
      default: this.inputTarget.value,
      swatches: this.swatches,
      components: this.componentOptions,
      i18n: this.i18n
    })

    this.picker.on("save", this.onSave)
    console.log("ColorPickerController connected")
  }

  onSave(color) {
    super.onSave(color)
  }

  get componentOptions() {
    return {
      preview: true,
      hue: true,
      theme: "nano", // or 'monolith', or 'classic'

      interaction: {
        input: true,
        clear: false,
        save: true,
      },
    }
  }

  get swatches() {
    return [
      "#644170",
      "#065BE5",
      "#FFFFFF",
      "#000000",
      "#A0AEC0",
      "#F56565",
      "#ED8936",
      "#ECC94B",
      "#48BB78",
      "#38B2AC",
      "#4299E1",
      "#667EEA",
      "#9F7AEA",
      "#ED64A6",
    ]
  }

  // Customize i18n text for Pickr buttons
  get i18n() {
    return {
      "btn:save": "OK",
    }
  }
}
